import { styled } from '@mui/material';
import MuiAccordion, { AccordionProps } from '@mui/material/Accordion';

const Accordion = styled((props: AccordionProps) => <MuiAccordion elevation={0} {...props} />)(() => ({
  '&:before': { display: 'none' },
  margin: 0,
  '&.Mui-expanded': {
    margin: 0
  }
}));

export default Accordion;
